import {typographyStyles, constants, mediaQueryStyles as mq} from '@newsela/angelou';
import {css} from 'emotion';

import {breakpointSwitch} from '../style';

const {ui} = constants.colors;


const white = ui.white[700];
const presentationGrey = ui.greyDark[700];
const gridGap = '24px';

export const buttonWithPopOutStyle = {
  popOut: {'z-index': '1'},
  innerPopOut: {width: '250px'}
};

export const containerStyle = css({
  display: 'grid',
  gridTemplateAreas: '"logo skip alerts firstRight secondRight"',
  gridTemplateColumns: 'auto auto 1fr auto auto',
  padding: '12px 16px',
  alignItems: 'center',
  gridGap: gridGap,
  marginTop: 0,
  marginBottom: 0,
  li: {
    listStyle: 'none',
    marginBottom: 0,
  },
  [breakpointSwitch]: {
    padding: '0px 40px',
    height: '64px',
  }
});

export const presentationStyle = css({
  backgroundColor: ui.greyDark[700],
  // get skip to content
  'ul li:nth-child(2) a': {
    color: white,
  }
});

export const presentationButtonStyle = css({
  '&&': {
    marginRight: '-16px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: presentationGrey,
    'svg *': {
      stroke: white
    },
    '&&:hover *, &&:hover': {
      backgroundColor: white,
      color: presentationGrey,
      stroke: presentationGrey
    }
  }
});

export const viewModeMessageStyle = css({
  color: white,
  textAlign: 'center',
  ...typographyStyles.text4Obj
});

export const tvSvgStyle = css({
  width: '24px',
  margin: '0 8px'
});

export const logoStyle = css({
  gridArea: 'logo',
});

export const skipStyle = css({
  gridArea: 'skip',
});

export const alertStyle = css({
  gridArea: 'alerts',
  display: 'flex',
  justifyContent: 'center'
});

export const edStyle = css({
  gridArea: 'firstRight',
  position: 'relative',
  ...typographyStyles.heading5Obj,
  marginLeft: `calc( -2 *${gridGap})`,
  [mq.mediaQuery.downTo(mq.Breakpoints.xs)]: {
    marginLeft: 0
  }
});

export const firstRight = css({
  gridArea: 'firstRight'
});

export const secondRight = css({
  gridArea: 'secondRight'
});

export const avatarStyle = css({
  gridArea: 'secondRight'
});


export const svgWrapperStyle = css({
  display: 'flex',
  alignItems: 'center'
});

export const windowSvgStyle = css({
  width: '24px'
});
